import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useToast } from '../../contexts/ToastContext';

const AUTH_EXPIRED_EVENT = 'auth-expired';

export function AuthExpiredHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const { showError } = useToast();

  useEffect(() => {
    const notifyAndRedirect = () => {
      // Avoid stacking multiple toasts on repeated events
      sessionStorage.removeItem('auth_expired');
      showError('Your session expired. Please sign in again.');
      if (location.pathname !== '/login') {
        navigate('/login', { replace: true });
      }
    };

    if (sessionStorage.getItem('auth_expired')) {
      notifyAndRedirect();
    }

    window.addEventListener(AUTH_EXPIRED_EVENT, notifyAndRedirect);
    return () => {
      window.removeEventListener(AUTH_EXPIRED_EVENT, notifyAndRedirect);
    };
  }, [navigate, location.pathname, showError]);

  return null;
}
